import { pb } from './pb';

// Création d'un message depuis le formulaire de contact
export async function createMessage(data){
  return pb.collection('messages').create({
    ...data,
    status: data.status || 'new',
  });
}

// Helpers admin pour plus tard
export async function fetchMessagesAdmin(page = 1, perPage = 30, filterStatus = 'all'){
  let filter = '';
  if(filterStatus === 'new') filter = "status = 'new'";
  else if(filterStatus === 'read') filter = "status = 'read'";
  else if(filterStatus === 'archived') filter = "status = 'archived'";

  return pb.collection('messages').getList(page, perPage, {
    filter,
    sort: '-created',
  });
}

export async function updateMessage(id, data){
  return pb.collection('messages').update(id, data);
}

export async function deleteMessage(id){
  return pb.collection('messages').delete(id);
}
